// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"334c7415","453":"8e0ecf00","667":"52937e80","977":"f92ec666"}[chunkId] + ".chunk.js";
};